import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';

import { Destroy, ExtendedRoute, ExtendedRoutes } from '@increff/commons';
import { APP_ROUTES } from '../../route-config';
import { ConfigService } from '../../services/config.service';
import { AuthNGuardService } from '../../services/authn-guard.service';

@Component({
    template: ''
})
export abstract class CommonSidebarComponent implements OnInit {
    parentRoute: ExtendedRoute;
    siblingRoutes: ExtendedRoutes;
    pageTitle: string;
    routeTree: ExtendedRoutes = APP_ROUTES;

    protected routeParentChildMap: any;

    constructor(protected router: Router, protected configService: ConfigService, protected readonly destroy$: Destroy, public authService: AuthNGuardService ) {
        router.events.pipe(
            filter((event) => (event instanceof NavigationEnd)),
        ).subscribe((event) => this.update(event));
    }

    ngOnInit() {
        this.configService.parentChildrenMap
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (parentChildMap) => this.routeParentChildMap = parentChildMap
            );
        this.configService.routeTree
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                routeTreeStructure => {
                    this.routeTree = routeTreeStructure;
                }
            );
        this.configService.pageHeader
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                pageHead => (this.pageTitle = pageHead)
            );
    }

    update(event: any) {
        const url = event.urlAfterRedirects.length === 1 ? 'home' : event.urlAfterRedirects.split('?')[0]; //Ignore only slash as it gives two tokens on splitting and query parameters
        const tokens: string[] = url.split('/');
        tokens.shift();
        /**Sidebar Siblings code */
        const parentRouteBase: string = url.replace(`/${tokens[tokens.length - 1]}`, '');
        this.siblingRoutes = this.routeParentChildMap[parentRouteBase || url] || this.routeParentChildMap['dummyOuter'];
        this.sendOutputEvent();
        this.setParentRoute(parentRouteBase);
        this.setPageHeader(parentRouteBase, tokens);
        /**Sidebar Siblings code end */
    }

    private setParentRoute(parentRouteBase: string) {
        this.parentRoute = null;
        if (!this.siblingRoutes?.length)
            return;

        for (const item of this.routeTree)
            if (parentRouteBase === item.baseUrl)
                this.parentRoute = item;

    }

    private setPageHeader(parentRouteBase: string, token: any[]) {
        if (!token?.length) {
            this.configService.pageHeaderSource.next('');
            return;
        }
        const currentPageToken = token[token.length - 1];
        if (!parentRouteBase) {
            for (const item of this.routeTree)
                if (`/${currentPageToken}` === item.baseUrl) {
                    this.configService.pageHeaderSource.next(item?.name ? item?.title || item.name : '');
                    return;
                }

            this.configService.pageHeaderSource.next('');
        } else {
            if (!this.siblingRoutes?.length) {
                this.configService.pageHeaderSource.next('');
                return;
            }
            for (const item of this.siblingRoutes)
                if (`${parentRouteBase}/${currentPageToken}` === item.baseUrl) {
                    this.configService.pageHeaderSource.next(item?.name ? item?.title || item.name : '');
                    return;
                }

            this.configService.pageHeaderSource.next('');
        }
    }

    abstract sendOutputEvent();

}
